module.exports = __webpack_public_path__ + "media/images/round-right-ab78d1e5786434c6edc21088753f6da2.svg";